import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MobileMenu from "../components/MobileMenu";
import hireCuraIcon from "../assets/hirecura-icon.png";
import {
  FaUsers,
  FaShieldAlt,
  FaFileAlt,
  FaHeadset,
  FaUserPlus,
  FaCheckCircle,
  FaArrowRight,
  FaUser,
} from "react-icons/fa";
import LoginModal from "../components/LoginModal";

import Footer from "../components/Footer";
import healthcareHero from "../assets/for-employers-hero.png";

function ForEmployers() {
  const navigate = useNavigate();
   const [showLoginModal, setShowLoginModal] = useState(false);
const [loginRole, setLoginRole] = useState("candidate");

const openLoginModal = (role) => {
  setLoginRole(role);
  setShowLoginModal(true);
};

  const [loggedUser, setLoggedUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      return null;
    }
  });

 

  return (
    <div className="min-h-screen bg-white">

      {/* ================= HEADER ================= */}
      <header className="sticky top-0 z-50 bg-white border-b border-gray-100">

        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">

          <div className="flex w-full min-w-0 items-center justify-between gap-3">

            {/* LOGO */}
            {/* LOGO */}
<div
  className="cursor-pointer flex min-w-0 items-center gap-2 sm:gap-3 flex-shrink-0"
  onClick={() =>
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }
>
  {/* HireCura Icon */}
  <img
    src={hireCuraIcon}
    alt="HireCura Icon"
    className="h-9 w-9 sm:h-11 sm:w-11 md:h-12 md:w-12 object-contain"
  />

  {/* Brand Name and Tagline */}
  <div className="flex flex-col">
    <h1 className="text-xl sm:text-2xl md:text-3xl font-bold tracking-tight leading-none">
      <span className="text-slate-900">Hire</span>
      <span className="text-teal-600">Cura</span>
    </h1>

    <p className="text-[9px] sm:text-[10px] md:text-xs text-slate-500 font-medium tracking-wide mt-1">
      Where Careers Meet Care.
    </p>
  </div>
</div>


            {/* NAVIGATION */}
            <nav className="hidden lg:flex items-center gap-8">

              <button
                onClick={() => navigate("/")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                Home
              </button>

              <button
                onClick={() => navigate("/find-jobs")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                Find Jobs
              </button>

              {/* ACTIVE */}
              <button
                className="relative text-teal-600 font-semibold"
              >
                For Employers

                <span className="absolute -bottom-5 left-0 right-0 h-[3px] bg-teal-600 rounded-full" />
              </button>

              <button
                onClick={() => navigate("/how-it-works")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                How It Works
              </button>

              <button
                onClick={() => navigate("/about-us")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                About Us
              </button>

              <button
                onClick={() => navigate("/contact-us")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                Contact Us
              </button>

            </nav>


            {/* RIGHT SIDE */}
            
<div className="hidden md:flex items-center gap-4">
  {loggedUser ? (
    <>
      <FaUser className="text-[#10243e] text-lg" />
      <span className="hidden xl:block text-sm font-semibold text-gray-700">
        Welcome, {loggedUser.name || "User"}
      </span>

      <button
        onClick={() =>
          navigate(
            loggedUser.role === "institution"
              ? "/institution"
              : "/candidate-dashboard"
          )
        }
        className="border border-teal-600 text-teal-700 px-6 py-2 rounded-full font-semibold hover:bg-teal-50 transition"
      >
        Dashboard
      </button>

      <button
        onClick={() => {
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          setLoggedUser(null);
          navigate("/");
        }}
        className="border border-red-500 text-red-600 px-5 py-2 rounded-full hover:bg-red-50 transition"
      >
        Logout
      </button>
    </>
  ) : (
    <>
     <FaUser className="text-[#10243e] text-lg" />
      <button
       onClick={() => openLoginModal("candidate")}
        className="border border-teal-600 text-teal-700 px-6 py-2 rounded-full font-semibold hover:bg-teal-50 transition"
      >
        Login
      </button>

      <button
        onClick={() => openLoginModal("institution")}
        className="bg-teal-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-teal-700 transition"
      >
        Post a Job
      </button>
    </>
  )}
</div>

            <MobileMenu
              onLogin={() => openLoginModal("candidate")}
              loggedUser={loggedUser}
              onLogout={() => {
                localStorage.removeItem("user");
                localStorage.removeItem("token");
                setLoggedUser(null);
                navigate("/");
              }}
            />
          </div>

        </div>
      </header>


      {/* ================= HERO ================= */}
      <section className="relative overflow-hidden bg-gradient-to-br from-white via-[#f3fbfa] to-[#dff5f1]">

        <div className="max-w-7xl mx-auto px-5 sm:px-6">

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 sm:gap-10 items-center min-h-0 lg:min-h-[430px]">

            {/* LEFT */}
            <div className="relative z-10 py-10 sm:py-12 lg:py-14 max-w-2xl">

              <p className="text-xs sm:text-sm md:text-base tracking-[0.16em] sm:tracking-[0.18em] text-[#10243e] font-medium mb-3 sm:mb-4">
                FOR EMPLOYERS
              </p>

              <h1 className="text-[2rem] sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.12] sm:leading-[1.08] text-[#10243e] tracking-tight">

                Find the Right
                <br />

                <span className="text-teal-600">
                  Healthcare Talent
                </span>

              </h1>

              <p className="mt-4 sm:mt-5 text-[15px] sm:text-lg text-gray-600 max-w-xl leading-6 sm:leading-7">
                Hire qualified doctors, nurses, technicians, healthcare
                faculty and more — from a trusted pool of professionals
                across India.
              </p>

              <button
                onClick={() => openLoginModal("institution")}
                className="mt-6 sm:mt-7 w-full sm:w-auto bg-teal-600 hover:bg-teal-700 text-white px-6 sm:px-8 py-3 sm:py-3.5 rounded-xl font-semibold text-base sm:text-lg flex items-center justify-center sm:justify-start gap-3 transition"
              >
                Post a Job
                <FaArrowRight className="text-sm" />
              </button>

            </div>


            {/* RIGHT IMAGE */}
            <div className="relative hidden md:flex justify-end items-end h-full min-h-[430px]">

              <div className="absolute right-[-80px] bottom-0 w-[620px] h-[400px] bg-teal-100/70 rounded-t-full" />

              <img
                src={healthcareHero}
                alt="Healthcare professionals"
                className="relative z-10 w-full max-w-[570px] h-[400px] object-cover object-top rounded-t-[180px]"
              />


              {/* FLOATING CARD */}
              <div className="absolute z-20 right-[-20px] top-[125px] bg-white rounded-2xl shadow-xl px-5 py-4 flex items-center gap-3">

                <div className="w-12 h-12 rounded-full bg-[#e5f8f5] flex items-center justify-center">
                  <FaUsers className="text-teal-600 text-xl" />
                </div>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* ================= BENEFITS ================= */}
      <section className="bg-[#f3fbfa] border-y border-teal-50">

        <div className="max-w-7xl mx-auto px-5 sm:px-6 py-4 sm:py-6">

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 divide-y divide-teal-100 md:divide-y-0">

            {/* 1 */}
            <div className="flex items-center gap-3 sm:gap-4 px-2 sm:px-5 py-3 sm:py-4 border-b lg:border-b-0 lg:border-r border-teal-100">

              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#e1f8f3] flex items-center justify-center flex-shrink-0">
                <FaUsers className="text-2xl sm:text-3xl text-teal-600" />
              </div>

              <div>
                <h3 className="font-bold text-[#10243e]">
                  Access Qualified Talent
                </h3>

                <p className="text-sm text-gray-500 mt-1">
                  Verified healthcare professionals
                </p>
              </div>

            </div>


            {/* 2 */}
            <div className="flex items-center gap-3 sm:gap-4 px-2 sm:px-5 py-3 sm:py-4 border-b lg:border-b-0 lg:border-r border-teal-100">

              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#e1f8f3] flex items-center justify-center flex-shrink-0">
                <FaShieldAlt className="text-2xl sm:text-3xl text-teal-600" />
              </div>

              <div>
                <h3 className="font-bold text-[#10243e]">
                  Save Time
                </h3>

                <p className="text-sm text-gray-500 mt-1">
                  Streamlined hiring process
                </p>
              </div>

            </div>


            {/* 3 */}
            <div className="flex items-center gap-3 sm:gap-4 px-2 sm:px-5 py-3 sm:py-4 border-b lg:border-b-0 lg:border-r border-teal-100">

              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#e1f8f3] flex items-center justify-center flex-shrink-0">
                <FaFileAlt className="text-2xl sm:text-3xl text-teal-600" />
              </div>

              <div>
                <h3 className="font-bold text-[#10243e]">
                  Post Jobs Easily
                </h3>

                <p className="text-sm text-gray-500 mt-1">
                  Reach the right candidates
                </p>
              </div>

            </div>


            {/* 4 */}
            <div className="flex items-center gap-3 sm:gap-4 px-2 sm:px-5 py-3 sm:py-4">

              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#e1f8f3] flex items-center justify-center flex-shrink-0">
                <FaHeadset className="text-2xl sm:text-3xl text-teal-600" />
              </div>

              <div>
                <h3 className="font-bold text-[#10243e]">
                  Dedicated Support
                </h3>

                <p className="text-sm text-gray-500 mt-1">
                  Assistance whenever you need
                </p>
              </div>

            </div>

          </div>

        </div>

      </section>


      {/* ================= HOW IT WORKS ================= */}
      <section className="bg-white py-10 sm:py-14 md:py-16">

        <div className="max-w-7xl mx-auto px-5 sm:px-6">

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#10243e]">
            How It Works
          </h2>

          <p className="text-gray-500 mt-2 text-base sm:text-lg">
            Start hiring in simple steps
          </p>


          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-10 mt-7 sm:mt-10">

            {/* STEP 1 */}
            <div className="relative flex gap-4 sm:gap-5 rounded-2xl border border-teal-100 bg-[#fbfefd] p-4 sm:rounded-none sm:border-0 sm:bg-transparent sm:p-0">

              <div className="w-11 h-11 sm:w-14 sm:h-14 rounded-full bg-[#e8faf7] text-teal-600 flex items-center justify-center font-bold text-base sm:text-lg flex-shrink-0">
                01
              </div>

              <div>

                <FaFileAlt className="text-3xl sm:text-4xl text-teal-600 mb-3" />

                <h3 className="text-lg sm:text-xl font-bold text-[#10243e]">
                  Post a Job
                </h3>

                <p className="text-gray-500 mt-2 leading-6">
                  Create a job listing with your requirements.
                </p>

              </div>

            </div>


            {/* STEP 2 */}
            <div className="relative flex gap-4 sm:gap-5 rounded-2xl border border-teal-100 bg-[#fbfefd] p-4 sm:rounded-none sm:border-0 sm:bg-transparent sm:p-0">

              <div className="w-11 h-11 sm:w-14 sm:h-14 rounded-full bg-[#e8faf7] text-teal-600 flex items-center justify-center font-bold text-base sm:text-lg flex-shrink-0">
                02
              </div>

              <div>

                <FaUsers className="text-3xl sm:text-4xl text-teal-600 mb-3" />

                <h3 className="text-lg sm:text-xl font-bold text-[#10243e]">
                  Get Applications
                </h3>

                <p className="text-gray-500 mt-2 leading-6">
                  Receive applications from qualified healthcare professionals.
                </p>

              </div>

            </div>


            {/* STEP 3 */}
            <div className="relative flex gap-4 sm:gap-5 rounded-2xl border border-teal-100 bg-[#fbfefd] p-4 sm:rounded-none sm:border-0 sm:bg-transparent sm:p-0">

              <div className="w-11 h-11 sm:w-14 sm:h-14 rounded-full bg-[#e8faf7] text-teal-600 flex items-center justify-center font-bold text-base sm:text-lg flex-shrink-0">
                03
              </div>

              <div>

                <FaUserPlus className="text-3xl sm:text-4xl text-teal-600 mb-3" />

                <h3 className="text-lg sm:text-xl font-bold text-[#10243e]">
                  Hire the Best
                </h3>

                <p className="text-gray-500 mt-2 leading-6">
                  Review profiles and connect with the right candidates.
                </p>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* ================= CTA ================= */}
      <section className="max-w-7xl mx-auto px-5 sm:px-6 pb-5 sm:pb-4">

        <div className="bg-gradient-to-r from-[#e9faf7] to-[#f2fbfa] rounded-2xl px-5 sm:px-8 py-6 sm:py-6 flex flex-col md:flex-row items-stretch md:items-center justify-between gap-5 sm:gap-6">

          <div>

            <h2 className="text-xl sm:text-2xl md:text-3xl font-bold leading-snug text-[#10243e]">
              Ready to Hire Healthcare Talent?
            </h2>

            <p className="text-sm sm:text-base text-gray-600 mt-2 leading-6">
              Join HireCura and build your team with skilled and verified
              healthcare professionals.
            </p>

          </div>

          <button
            onClick={() => openLoginModal("institution")}
            className="w-full md:w-auto flex-shrink-0 bg-teal-600 hover:bg-teal-700 text-white px-6 sm:px-8 py-3 sm:py-3.5 rounded-xl font-semibold flex items-center justify-center gap-3 transition"
          >
            Post a Job
            <FaArrowRight className="text-sm" />
          </button>

        </div>

      </section>


      {/* ================= FOOTER ================= */}
      <Footer />
  <LoginModal
  isOpen={showLoginModal}
  initialRole={loginRole}
  onClose={() => setShowLoginModal(false)}
/>
    </div>
  );
}

export default ForEmployers;